import { ID } from '../../utils/codecUtils';
import { z } from 'zod';

export const deleteEndpoint = (fieldId: ID) => {
  return {
    endpoint: `/engine_fields/${fieldId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
